import { render, staticRenderFns } from "./CategoriesKeywords.vue?vue&type=template&id=e3a76c58&scoped=true"
import script from "./CategoriesKeywords.vue?vue&type=script&lang=js"
export * from "./CategoriesKeywords.vue?vue&type=script&lang=js"
import style0 from "./CategoriesKeywords.vue?vue&type=style&index=0&id=e3a76c58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3a76c58",
  null
  
)

export default component.exports